import { MdMenu } from 'react-icons/md';

import Action from '../navbar/Action';

import haggleLogoSrc from '@/assets/haggle-logo.png';
import { useUser } from '@/hooks/useUser';
import { UserRole } from '@/interfaces/api/user/UserRole.enum';

type Props = {
	onMenuClick?: () => void;
};

const DashboardHeader = ({ onMenuClick }: Props) => {
	const { user } = useUser();
	const isConsumerOrGuest = !user || user.roles.includes(UserRole.Consumer);

	return (
		<header className="sticky top-0 z-[90] flex w-full">
			<div className="flex w-full items-center justify-between py-2 px-4 md:px-10 2xl:px-14 gap-10">
				<div className="flex items-center gap-4">
					<button
						className="text-gray-700 md:hidden"
						onClick={onMenuClick}
						aria-label="Toggle sidebar"
					>
						<MdMenu size={25} />
					</button>

					{isConsumerOrGuest && (
						<img
							src={haggleLogoSrc}
							alt="Omnicierge Logo"
							className="h-8 md:h-10 object-contain"
						/>
					)}
				</div>

				<div className="flex items-center gap-4 ml-auto">
					<Action />
				</div>
			</div>
		</header>
	);
};

export default DashboardHeader;
